<template lang="pug">
  section.section.collection(
    :style="{'background': 'linear-gradient(2.77deg, #ffffff 9.31%, ' +collection.background+' 89.91%)'}",
    :class="{ 'collection--first' : collection.slug === 'fizzy' }"
  )
    SectionWave(:color="collection.background", :collectionSlug="collection.slug")
    SectionTitle(v-if="collection.slug === 'fizzy'", text="Коллекция изысканных впечатлений", number="1").section--first__title
    .collection__heading
      h3.collection__title.subtitle(v-if="collection.title" v-fade) {{ collection.title }}
      .collection__description.text-body(v-fade) {{ collection.description }}
    .collection__layout
      .container
        .row.center-md.center-lg.center-xl
          .col-xs-12.col-md-6(v-for="(item, index) in collection.items", :class="{ 'col-xl-4' : !item.isSmall, 'col-sm-offset-2 col-sm-8 col-md-offset-0 col-lg-4 col-xl-3' : item.isSmall }")
            .parallax-wrapper(data-type="parallax", :data-depth="item.parallaxDepth")
              .item(
                :key="item.slug",
                :id="item.slug",
                v-fade, 
                :data-delay="item.fadeDelay"
              )
                a.item-link(@click="$emit('open-popup', { slug: collection.slug, index, itemId: item.slug })")
                  ItemCard(:item="item", :ref="`${index}ItemCard`")
</template>

<script>
import SectionTitle from "./SectionTitle.vue";
import ItemCard from "./ItemCard.vue";
import SectionWave from "./SectionWave.vue";
import FullItem from "./FullItem.vue";

export default {
  name: "Collection",
  components: {
    SectionTitle,
    FullItem,
    SectionWave,
    ItemCard
  },
  props: {
    collection: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.section--first__title {
  margin-bottom: 58px;
}
.collection {
  position: relative;
  margin-top: 100px;

  &--first {
    margin-top: 100px;
  }

  @include from("xl") {
    margin-top: 300px;
    &--first {
      margin-top: 100px;
    }
  }
  @include from("xxxl") {
    padding-bottom: 200px;
  }

  &__heading {
    text-align: center;
    margin: 0 auto;
    width: 85%;

    @include from("md") {
      width: 80%;
    }
    @include from("lg") {
      width: 70%;
    }
    @include from("xxxl") {
      width: 40%;
    }
  }
  &__title {
    margin-bottom: 15px;
  }
  &__description {
    width: 80%;
    margin: auto;

    @include from("md") {
      width: 90%;
    }
    @include from("xl") {
      width: 750px;
    }
    @include from("xxxl") {
      width: 1050px;
    }
  }
  &__layout {
    padding-top: 50px;

    @include from("md") {
      padding-top: 90px;
    }
  }
}

.item-link {
  display: block;
  cursor: pointer;
}
</style>
